import type React from "react";
import { theme } from "../theme";

import { cbPalette } from "./colourBlind";
// The sign-in pages (Login, InviteRedeem, ResetPassword, SignedOut) sit over the blueprint
// backdrop (components/BlueprintBackdrop.tsx surface="login"), which is always the dark nebula
// whatever theme the person last chose — and some of them render before any theme applies. So they
// share this one fixed dark palette rather than the --c-* variables, and one sheet style: a dark
// glass card with the flat offset shadow, as the drawing sheets inside the app.
export const SIGN_IN = cbPalette({
  card:       "rgba(20, 4, 50, 0.82)",
  border:     "rgba(230, 0, 180, 0.25)",
  borderSel:  "#ff00aa",
  accent:     "#e600c8",
  accentBg:   "rgba(230, 0, 180, 0.15)",
  heading:    "#ffffff",
  text:       "#e2d9f3",
  subtle:     "#b49fd8",
  danger:     "#ff6ec7",
  dangerBg:   "rgba(255, 110, 199, 0.10)",
  success:    "#8ef0c2",
  successBg:  "rgba(142, 240, 194, 0.10)",
  inputBg:    "rgba(255, 255, 255, 0.06)",
  btnText:    "#ffffff",
});

export const signInSheet: React.CSSProperties = {
  background: SIGN_IN.card,
  border: `1px solid ${SIGN_IN.border}`,
  borderRadius: theme.radius.lg,
  padding: 24,
  width: "100%",
  position: "relative",
  zIndex: 1,
  boxShadow: "6px 6px 0 rgba(0,0,0,0.45)",
  backdropFilter: "blur(12px)",
  WebkitBackdropFilter: "blur(12px)",
};

/** A secondary action on a sign-in sheet: outlined, on the glass. */
export const signInSecondaryButton: React.CSSProperties = {
  background: SIGN_IN.inputBg,
  border: `1px solid ${SIGN_IN.border}`,
  borderRadius: theme.radius.sm,
  padding: "10px 16px",
  fontSize: 13,
  fontWeight: 600,
  color: SIGN_IN.text,
  cursor: "pointer",
};
